import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthStateService } from '../services/auth-state.service';
import { ADMIN_ROLES } from '../constants';

/**
 * Restricts a route to admin roles (see ADMIN_ROLES). Non-admins — including
 * unauthenticated users — are redirected to /home. Pair with authGuard so the
 * login redirect still applies: `canActivate: [authGuard, adminGuard]`.
 */
export const adminGuard: CanActivateFn = () => {
  const auth = inject(AuthStateService);
  const router = inject(Router);

  const role = auth.userProfile()?.role ?? '';
  if (auth.isAuthenticated() && (ADMIN_ROLES as readonly string[]).includes(role)) {
    return true;
  }

  return router.createUrlTree(['/home']);
};
